import React, { Fragment, useEffect, useRef, useState } from "react";
import { useField, useFormikContext } from "formik";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import SummaryItem from "../components/SummaryItem/SummaryItem";
import DatePicker, { registerLocale } from "react-datepicker";
import { it, enUS } from "date-fns/locale";
import i18n from "../../../i18n";
import * as select from "tail.select";

import moment from "moment";
import "react-datepicker/dist/react-datepicker.module.css";
import "./DateField.scss";

export default function DatepickerField(props) {
  const {
    errorText,
    onDateChanged,
    setToday,
    twoYearsAgo,
    validationSchema,
    ...rest
  } = props;
  const [field, meta] = useField(props);
  const { summaryMode } = rest;
  const { t } = useTranslation();
  const hasIcon = props.leftIcon ? "has-icon" : "";
  const { values, setFieldValue } = useFormikContext();
  const fieldRefClass = "select-" + field.name;

  const getYear = (date) => date.getFullYear();
  const getMonth = (date) => date.getMonth();
  const range = (start, stop, step) => {
    let a = [stop],
      b = stop;
    while (b > start) {
      a.push((b -= step || 1));
    }
    return a;
  };
  const isRequired = validationSchema?.fields[field.name]?._exclusive?.required;

  const currentLanguage = i18n.language === "it-IT" ? "it" : "en";

  currentLanguage === "it"
    ? registerLocale([currentLanguage], it)
    : registerLocale([currentLanguage], enUS);

  const [startDate, setStartDate] = useState(null);

  useEffect(() => {
    if (setToday) {
      const date = new Date();
      setStartDate(date);
      if (onDateChanged) {
        onDateChanged(date, values, setFieldValue);
      }
      setFieldValue(field.name, date);
    }
    // eslint-disable-next-line
  }, [setToday]);

  useEffect(() => {
    if (twoYearsAgo) {
      const date = new Date() - 86400000 * 731;
      setStartDate(new Date(date));
      if (onDateChanged) {
        onDateChanged(date, values, setFieldValue);
      }
      setFieldValue(field.name, new Date(date));
    }
    // eslint-disable-next-line
  }, [twoYearsAgo]);

  function CustomHeader(props) {
    const {
      date,
      changeYear,
      changeMonth,
      decreaseMonth,
      increaseMonth,
      prevMonthButtonDisabled,
      nextMonthButtonDisabled,
    } = props;
    const headerRef = useRef(null);
    console.log(props);
    useEffect(() => {
      if (headerRef.current) {
        updateSelect();
      }
    }, [date]);

    const updateSelect = () => {
      if (!summaryMode) {
        let SelectFieldObject = null;
        const actSelect = (selectType) => {
          const _onChange = (item) => {
            if (selectType === "-year") {
              changeYear(item.value);
            } else {
              changeMonth(months.indexOf(item.value));
            }
            const wrapper = item?.option?.parentNode?.nextSibling;
            if (wrapper && item.value) {
              wrapper.classList.remove("gcap-tail-select--no-selection");
            } else {
              wrapper.classList.add("gcap-tail-select--no-selection");
            }
          };
          try {
            SelectFieldObject = select("." + fieldRefClass + selectType, {
              classNames:
                "gcap-tail-select default gcap-tail-select--no-selection select" +
                selectType, // For our demonstration only
              descriptions: true,
              placeholder: "",
              locale: localStorage.getItem("i18nextLng").split("-")[0],
              width: "100%",
            });
            if (SelectFieldObject) {
              SelectFieldObject.on("change", _onChange);
              SelectFieldObject.reload();
            }
          } catch (error) {
            console.log("Cannot rendered field" + fieldRefClass);
          }
        };
        actSelect("-year");
        actSelect("-month");
        return () => {
          document.removeEventListener("DOMContentLoaded", actSelect);
        };
      }
    };

    return (
      <div ref={headerRef}>
        <button
          className="button-previous-month"
          onClick={() => {
            decreaseMonth();
          }}
          disabled={prevMonthButtonDisabled}
          type="button"
          aria-label={t("date.field.button.prev")}
        >
          <span className="gc-icon-thick-chevron-back" aria-hidden="true" />
        </button>

        <Form.Control
          as="select"
          className={
            fieldRefClass + "-year gcap-select custom-select form-control"
          }
          value={getYear(date)}
          id={field.name + "-year-select"}
          onChange={({ target: { value } }) => changeYear(value)}
        >
          {years.map((option) => {
            return (
              <option value={option} key={field.name + "-" + option}>
                {option}
              </option>
            );
          })}
        </Form.Control>
        <Form.Control
          as="select"
          className={
            fieldRefClass + "-month gcap-select custom-select form-control"
          }
          value={months[getMonth(date)]}
          id={field.name + "-month-select"}
          onChange={({ target: { value } }) =>
            changeMonth(months.indexOf(value))
          }
        >
          {months.map((option) => {
            return (
              <option value={option} key={field.name + "-" + option}>
                {option}
              </option>
            );
          })}
        </Form.Control>

        <button
          className="button-next-month"
          onClick={() => {
            increaseMonth();
          }}
          disabled={nextMonthButtonDisabled}
          type="button"
          aria-label={t("date.field.button.next")}
        >
          <span className="gc-icon-thick-chevron-right" aria-hidden="true" />
        </button>
      </div>
    );
  }

  useEffect(() => {
    if (field.value) {
      setStartDate(new Date(field.value));
    } else {
      setStartDate("");
    }
  }, [field.value]);

  const years = range(1920, getYear(new Date()) + 1, 1);
  const months = [
    t("lists.months.january"),
    t("lists.months.february"),
    t("lists.months.march"),
    t("lists.months.april"),
    t("lists.months.may"),
    t("lists.months.june"),
    t("lists.months.july"),
    t("lists.months.august"),
    t("lists.months.september"),
    t("lists.months.october"),
    t("lists.months.november"),
    t("lists.months.december"),
  ];

  const _onChange = (date) => {
    if (onDateChanged) {
      onDateChanged(date, values, setFieldValue);
    }
    setFieldValue(field.name, date);
    setStartDate(date);
  };
  let labelFormatted = rest.label;
  if (summaryMode) {
    labelFormatted = rest.summaryLabel ? rest.summaryLabel : rest.label;
  }
  return (
    <Form.Group
      noValidate
      className={
        meta.touched && meta.error
          ? "has-error date-field-group"
          : "date-field-group"
      }
    >
      {!summaryMode ? (
        <>
          {labelFormatted && (
            <Form.Label
              htmlFor={field.name}
              className="paragraph-small-fs9 font-color-1"
            >
              {labelFormatted}
            </Form.Label>
          )}
          <Fragment>
          <DatePicker
            disabled={rest.disabled}
            locale={currentLanguage}
            placeholderText={
              typeof rest.placeholder === "object"
                ? t(rest.placeholder.props.i18nKey)
                : rest.placeholder
            }
            dateFormat="dd/MM/yyyy"
            popperPlacement="bottom-start"
            popperModifiers={{
              flip: {
                enabled: true,
                behavior: ["bottom"], // don't allow it to flip to be above
              },
              preventOverflow: {
                enabled: true,
                escapeWithReference: false,
                // boundariesElement: "viewport",
              },
              hide: {
                enabled: false, // turn off since needs preventOverflow to be enabled
              },
            }}
            customInput={
              <Form.Control
                disabled={rest.disabled}
                type="text"
                name={field.name}
                placeholder={
                  typeof rest.placeholder === "object"
                    ? t(rest.placeholder.props.i18nKey)
                    : rest.placeholder
                }
                value={field.value || ""}
                onChange={field.onChange}
                className={
                  meta.touched && meta.error
                    ? `${hasIcon} is-invalid`
                    : `${hasIcon} nothing form-date-input`
                }
                style={{ width: "100%" }}
                autoComplete="off"
              />
            }
            renderCustomHeader={(props) => <CustomHeader {...props} />}
            selected={startDate}
            onChange={(date) => _onChange(date)}
            aria-describedby={
              meta.touched && meta.error ? field.name + "-error" : null
            }
            required={isRequired}
            id={field.name}
          />

          {meta.touched && meta.error && (
            <p
              className="form-error-text paragraph-small-form"
              role="alert"
              id={field.name + "-error"}
            >
              {meta.error}
            </p>
          )}
          {rest.leftIcon && <i className={rest.leftIcon} aria-hidden="true" />}
          </Fragment>
        </>
      ) : (
        <>
          {labelFormatted && (
          <span className="paragraph-small-fs9">
            {labelFormatted}
          </span>
          )}
          <SummaryItem
            value={field.value ? moment(field.value).format("DD/MM/yyyy") : ""}
            error={meta.error}
          />
        </>
      )}
      {props.subtitle ? (
        <p className="paragraph-small-form">{props.subtitle}</p>
      ) : null}
    </Form.Group>
  );
}
